import { SET_PAGE_TITLE, SET_PAGE_SUB_TITLE } from './types';

export const setPageTitle = title => {
  return dispatch => {
    dispatch({ type: SET_PAGE_TITLE, title });
  };
};
export const setPageSubTitle = subtitle => {
  return dispatch => {
    dispatch({ type: SET_PAGE_SUB_TITLE, subtitle });
  };
};
